import { Box, Divider, Grid, SxProps } from '@mui/material';
import Typography from '../Typography';
import DetailField from '../DetailField';
import { ReactNode, isValidElement } from 'react';

const DetailsSection = ({
  title,
  details = [],
  size = 6,
  isLongValue,
  description,
  sx = {},
  trackingEvent,
  endAction,
}: {
  title?: string;
  details?: {
    label?: string;
    value: string | ReactNode | (() => string);
    copyable?: boolean;
    formatValue?: (value: string) => string;
  }[];
  size?: number;
  isLongValue?: boolean;
  description?: string | ReactNode;
  sx?: SxProps;
  trackingEvent?: string;
  endAction?: ReactNode;
}) => {
  // if value is a function, call it to get the value
  const _details = details.map((detail) => {
    if (typeof detail.value === 'function') {
      return { ...detail, value: detail.value() };
    }
    return detail;
  });

  return (
    <Box sx={{ border: '1px solid #D7E1F5', borderRadius: '8px', padding: '1em', ...sx }}>
      <Grid container spacing={1.5}>
        {title && (
          <>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
            >
              <Typography sx={{ fontWeight: '500', fontSize: '16px', lineHeight: '24px', color: '#283952' }}>
                {title}
              </Typography>
              {endAction && <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>{endAction}</Box>}
            </Grid>
            <Grid item xs={12}>
              <Divider sx={{ borderColor: '#E4EEFC' }} />
            </Grid>
          </>
        )}
        {_details.map(({ label, value, copyable, formatValue }) => (
          <Grid item xs={12} key={label || (typeof value === 'string' ? value : label)}>
            {value === '__divider__' ? (
              <Divider sx={{ marginY: '0.5em' }} />
            ) : isValidElement(value) ? (
              <Grid container sx={{ alignItems: 'center' }}>
                <Grid item xs={size}>
                  <Typography textAlign="start" fontWeight={700} sx={{ color: '#4F5A84' }}>
                    {label}
                  </Typography>
                </Grid>
                <Grid item xs={size} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  {value}
                </Grid>
              </Grid>
            ) : (
              <DetailField
                title={label || (value as string)}
                value={value as string}
                size={size}
                copyable={copyable}
                isLongValue={isLongValue}
                formatValue={formatValue}
                trackingEvent={trackingEvent}
              />
            )}
          </Grid>
        ))}
        {description && (
          <Grid item xs={12}>
            <Typography>{description}</Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default DetailsSection;
